<template>
  <div class="list row">
    <h2>Tipovi zamenskih vozila</h2>
    <div class="actions d-flex flex-row-reverse">
      <button
        type="button"
        class="btn btn-primary bi bi-arrow-clockwise"
        @click="refreshData"
      />
      <button
        type="button"
        class="btn btn-success bi bi-plus"
        @click="addData"
      />
    </div>
    <data-table
      url="vehicle-replacement-type"
      :columns="columns"
      :templates="templates"
      :headings="headers"
      :actions="actions"
      ref="datatable"
      @yes="deleteData"
      name="VehicleReplacementType"
    >
    </data-table>
  </div>
</template>

<script>
import VehicleReplacementTypeDataService from "../../services/vehicle-replacement-type.service";
import DataTable from "../widgets/DataTable.vue";
import VehicleReplacementTypeForm from "./VehicleReplacementTypeForm.vue";

export default {
  name: "vehicle-replacement-type",
  components: {
    DataTable,
  },
  data() {
    return {
      columns: ["name", "price_per_month", "edit"],
      headers: {
        name: "Naziv",
        price_per_month: "Cena po mesecu",
        edit: "",
      },
      templates: {},
      actions: {
        edit: { commp: VehicleReplacementTypeForm },
        delete: {
          deleteData: this.deleteData,
          color: "danger",
          icon: "bi-trash",
        },
      },
      currentTutorial: null,
      currentIndex: -1,
      title: "",
    };
  },
  methods: {
    refreshData() {
      this.$refs.datatable.onRefresh();
    },
    addData() {
      this.$store.commit("app/showModal", {
        modal: VehicleReplacementTypeForm,
        params: { data: {}, title: "Dodaj novi tip zamene vozila" },
      });
    },
    deleteData(id) {
      VehicleReplacementTypeDataService.delete(id)
        .then((response) => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: response.data.message,
          });
          this.$store.commit("app/hideModal");
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e,
          });
        });
    },
  },
};
</script>

<style scoped>
.list {
  text-align: left;
  margin: auto;
}
</style>
